@if (
  {
    favouriteTravellers: userService.favouriteTravellers | async
  };
  as data
) {
  <div class="frequent-travellers-tab background-container-background">
    @if (isLoadingFrequent) {
      <p i18n="@@LoadingUserData" tabindex="0">
        Loading User Data... <app-loading-spinner size="sm" />
      </p>
    }
    @if (data.favouriteTravellers?.length && !isLoadingFrequent) {
      <ul>
        @for (favTraveller of data.favouriteTravellers; track favTraveller) {
          <li>
            <app-traveller-detail
              [traveller]="favTraveller"
              class="flex-row-container flex-row-container--between traveller"
            ></app-traveller-detail>
          </li>
        }
      </ul>
    }
    @if (!data.favouriteTravellers?.length && !isLoadingFrequent) {
      <div class="recent_searches_no_recent">
        <fa-icon
          [icon]="faUser"
          placement="bottom"
          container="body"
          class="no_recent_icon"
          aria-hidden="true"
        >
        </fa-icon>
        <h2 class="no_recent_header" i18n="@@YouHaveNoFrequentTravellers" tabindex="0">
          You have no frequent travellers
        </h2>
        <p class="no_recent_tag_line" i18n="@@YouHaveNoFrequentTravellersMessage">
          To add a frequent traveller, go to the search form, add the desired traveller(s) and
          select the traveller icon at the side of their name.
        </p>
      </div>
    }
  </div>
}
